import * as React from "react"
import { cn } from "@/lib/utils"

interface LicensePlateProps extends React.HTMLAttributes<HTMLDivElement> {
  plateNumber: string
  countryCode?: string
}

const EUStars = () => (
  <svg viewBox="0 0 24 24" className="h-2.5 w-2.5">
    {Array.from({ length: 12 }).map((_, i) => {
      const angle = (i * 30 - 90) * (Math.PI / 180)
      const cx = 12 + 9 * Math.cos(angle)
      const cy = 12 + 9 * Math.sin(angle)
      return <circle key={i} cx={cx} cy={cy} r={1.5} fill="#FFD700" />
    })}
  </svg>
)

const LicensePlate = React.forwardRef<HTMLDivElement, LicensePlateProps>(
  ({ plateNumber, countryCode = "PL", className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "inline-flex h-[22px] items-stretch overflow-hidden rounded-[3px] border border-zinc-400 text-xs shadow-sm",
          className,
        )}
        {...props}
      >
        <div className="flex flex-col items-center justify-center gap-0 bg-[#003DA5] px-0.5">
          <EUStars />
          <span className="text-[6px] font-bold leading-none text-white">
            {countryCode}
          </span>
        </div>
        <div className="flex items-center border-l border-zinc-400 bg-white px-1.5">
          <span className="whitespace-nowrap font-mono text-[11px] font-bold leading-none tracking-wide text-black">
            {plateNumber}
          </span>
        </div>
      </div>
    )
  },
)
LicensePlate.displayName = "LicensePlate"

export { LicensePlate }
